import React from "react";
// import { pdfjs } from 'react-pdf';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/navbar.js";
import Home from "./components/home.js";
import Services from "./components/services.js";
import MobilePages from "./components/mobilePages.js";
import ComparePackage from "./components/comparePackage.js";
import SubscriptionPlan from "./components/subscriptionPlan.js";
import Video from "./components/video.js";
import FQA from "./components/fqa.js";
import Footer from "./components/footer.js";
// import PaymentPolicy from "./components/paymentPolicy.js";
// import TermsOfService from "./components/termsOfService.js";
// import CancelPolicy from "./components/cancelPolicy.js";
// import IntellectualClaim from "./components/intellectualClaim.js";
// import Disclaimer from "./components/disclaimer.js";
// import PrivacyPolicy from "./components/privacyPolicy.js";


// import PdfComp from "./components/pdf.js";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Set workerSrc to the public folder path
// pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.min.js`;


// Set the workerSrc
// pdfjs.GlobalWorkerOptions.workerSrc = require('pdfjs-dist/build/pdf.worker.min.js');

// pdfjs.GlobalWorkerOptions.workerSrc = workerSrc;


function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route
          path="/"
          // exact
          element={
            <>
              <Home />
              {/* <PdfComp /> */}
              <Video />
              <MobilePages />
              <ComparePackage />
              <SubscriptionPlan />
              <FQA />
              <Services />
              <Footer />
            </>
          }
        />
        {/* <Route path="/payment-policy" element={<PaymentPolicy />} /> */}
        {/* <Route path="/Terms-of-service" element={<TermsOfService />} />
        <Route path="/cancellation_refund_policy" element={<CancelPolicy />} />
        <Route path="/intellectual_property_claim" element={<IntellectualClaim />} />
        <Route path="/Disclaimer" element={<Disclaimer />} />
        <Route path="/privacy_policy" element={<PrivacyPolicy />} /> */}
      </Routes>

    </Router>
  );
}

export default App;
